import type { ChargeCategoriesConfig } from '@/domain/types/configs/company/ChargeCategoriesConfig'

export const chargeCategoriesConfig: ChargeCategoriesConfig = {
  categories: [
    {
      id: 'cat_proveedor',
      name: 'Gastos proveedor',
      description: 'Costos de mercancía, valor FOB, CIF, CFR, EXW. Facturas del proveedor/fabricante',
      isActive: true,
      order: 0,
      color: 'blue',
      isSupplierCost: true
    },
    {
      id: 'cat_agente_carga',
      name: 'Gastos agente de carga/naviera',
      description: 'Flete internacional, BL fee, booking, recargos de combustible (BAF/CAF), THC naviera',
      isActive: true,
      order: 1,
      color: 'purple',
      isSupplierCost: false
    },
    {
      id: 'cat_puerto',
      name: 'Gastos en puerto',
      description: 'THC, uso de instalaciones portuarias, inspección, maniobras, porteo',
      isActive: true,
      order: 2,
      color: 'cyan',
      isSupplierCost: false
    },
    {
      id: 'cat_origen',
      name: 'Gastos en origen',
      description: 'Gastos generados en el país de origen: consolidación, embalaje, certificaciones de origen',
      isActive: true,
      order: 3,
      color: 'green',
      isSupplierCost: false
    },
    {
      id: 'cat_destino',
      name: 'Gastos en destino',
      description: 'Gastos generados en el país de destino: desconsolidación, descarga, verificación',
      isActive: true,
      order: 4,
      color: 'emerald',
      isSupplierCost: false
    },
    {
      id: 'cat_agente_aduana',
      name: 'Gastos agente de aduana',
      description: 'Honorarios del agente aduanal, trámites de despacho, asesoría aduanera',
      isActive: true,
      order: 5,
      color: 'indigo',
      isSupplierCost: false
    },
    {
      id: 'cat_bancarios',
      name: 'Gastos bancarios',
      description: 'Comisiones bancarias, transferencias internacionales, cartas de crédito, financiamiento',
      isActive: true,
      order: 6,
      color: 'amber',
      isSupplierCost: false
    },
    {
      id: 'cat_aduana',
      name: 'Gastos aduana',
      description: 'Aranceles, IVA de importación, impuestos, derechos aduaneros, multas',
      isActive: true,
      order: 7,
      color: 'red',
      isSupplierCost: false
    },
    {
      id: 'cat_transporte',
      name: 'Gastos transporte nacional',
      description: 'Transporte terrestre interno, acarreo, distribución local, fletes nacionales',
      isActive: true,
      order: 8,
      color: 'orange',
      isSupplierCost: false
    },
    {
      id: 'cat_seguro',
      name: 'Gastos seguro',
      description: 'Prima de seguro de carga, cobertura de transporte, póliza de mercancía',
      isActive: true,
      order: 9,
      color: 'teal',
      isSupplierCost: false
    },
    {
      id: 'cat_otros',
      name: 'Otros',
      description: 'Gastos que no se ajustan a ninguna otra categoría',
      isActive: true,
      order: 10,
      color: 'gray',
      isSupplierCost: false
    }
  ]
}
